/**
 * @file 节流
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/throttle
 */
const DEFAULT_SHRESHHOLD = 250;

/**
 * 函数限流
 *
 * @function throttle
 * @param {Function} fn 需要做限流处理的函数
 * @param {number=} [threshhold=250] 限流时间阈值，单位毫秒，默认为 250
 * @param {*=} bind 针对 fn 最终调用时需要绑定的 this
 * @return {Function} 返回包装过带限流功能的 fn
 */
export default (fn, threshhold = DEFAULT_SHRESHHOLD, bind) => {
    let last;
    let timer;

    return (...args) => {
        const now = +new Date();
        const wrapper = () => {
            last = now;
            fn.apply(bind, args);
        };

        if (last && now < last + threshhold) {
            clearTimeout(timer);
            timer = setTimeout(wrapper, threshhold);
        }
        else {
            wrapper();
        }
    };
};
